import api from './api.js';

class SystemConfig {
    constructor(){
        // SystemConfig endpoints use proper case in routes
    }

    getMessage(){
        // Add cache-busting timestamp to prevent browser caching
        const timestamp = Date.now();
        return api.get(`SystemConfig/SystemAnnouncement?_t=${timestamp}`, { isDataSourceRequest: true });
    }

    getMessageAdmin(){
        return api.get(`SystemConfig/SystemAnnouncementAdmin`);
    }

    getDailyMessage(){
        return api.get('daily-message');
    }

    getDeploymentLock() {
        const timestamp = Date.now();
        return api.get(`SystemConfig/DeploymentLock?_t=${timestamp}`, { isDataSourceRequest: true });
    }

    putDeploymentLock(lockData) {
        return api.put(`SystemConfig/DeploymentLock`, lockData);
    }

    putMessage(messageObj){
        return api.put(`SystemConfig/SystemAnnouncement`, messageObj);
    }
}

export default new SystemConfig;